












































  import { Component, Prop, Vue } from 'vue-property-decorator'
	import PhoneMaskInput from  "vue-phone-mask-input";

  @Component({
    components: {
			PhoneMaskInput
		}
  })
  export default class AccessInvitationModal extends Vue{
    invitation = {
        mobile_phone_number: "",
        first_name: null,
        last_name: null,
        started_at: null,
        user_type: null,
        owner_title: null,
    }

		validPhoneNumber = false

    selected = ""
    options = [
      { value: 'owner', text: 'Propriétaire' },
      { value: 'family', text: 'Famille' },
      { value: 'tenant', text: 'Locataire' },
      { value: 'other', text: 'Autre' },
    ]

    @Prop({ default: false })
    isActive:any

    @Prop({ default: null })
    access:any

    closeModal() {
        this.$emit('close')
    }

		isValid(payload: any) {
			this.validPhoneNumber = payload.isValidByLibPhoneNumberJs
		}

    get today() {
      var today = new Date()
      var today = new Date(today.getFullYear(), today.getMonth(), today.getDate())
      return today
    }

    sendInvitation() {
        if (this.formIsValid) {
          this.$emit('send-invitation', {
            mobile_phone_number: this.invitation.mobile_phone_number,
            first_name: this.invitation.first_name,
            last_name: this.invitation.last_name,
            started_at: this.invitation.started_at,
            user_type: this.invitation.user_type,
            owner_title: this.invitation.owner_title
          })
          this.$emit('close')
        } else {
          return
        }
    }

    get formIsValid() {
      if (this.invitation.mobile_phone_number && /^(.+)\d+$/.test(this.invitation.mobile_phone_number) && this.validPhoneNumber && this.invitation.first_name && this.invitation.last_name && (this.invitation.started_at || !this.access.permissions.started_at_updatable) && this.invitation.user_type) {
        return true
      } else {
        return false
      }
    }
  }
